(() => {
  'use strict';
  const popup = document.getElementById('iglam-sale-popup');
  if (!popup || typeof popup.showModal !== 'function' || window.Shopify?.designMode) return;
  const key = 'iglam_sale_campaign_v3_shown_at';
  const interval = 24 * 60 * 60 * 1000;
  const desktop = window.matchMedia('(min-width: 750px) and (min-height: 521px)');
  const images = Array.from(popup.querySelectorAll('img[data-src]'));
  let preparing = null;
  let fontsReady;
  function lastShown() {
    let stored = 0;
    try { stored = Number(localStorage.getItem(key)) || 0; } catch (_) { /* Cookie fallback. */ }
    const cookie = document.cookie.split('; ').find(value => value.startsWith(key + '='));
    return Math.max(stored, cookie ? Number(cookie.slice(key.length + 1)) || 0 : 0);
  }
  function isDue() {
    const now = Date.now();
    const last = lastShown();
    return !(last > 0 && now - last < interval);
  }
  function visibleImages() {
    return desktop.matches ? images : [];
  }
  async function loadVisibleImages() {
    await Promise.all(visibleImages().map(async image => {
      if (!image.getAttribute('src')) image.src = image.dataset.src;
      await image.decode();
    }));
  }
  function showIfDue() {
    if (document.visibilityState === 'hidden' || popup.open || !isDue()) return;
    popup.style.removeProperty('display');
    popup.showModal();
    const now = Date.now();
    try { localStorage.setItem(key, String(now)); } catch (_) { /* Cookie fallback. */ }
    document.cookie = `${key}=${now}; Max-Age=86400; Path=/; SameSite=Lax; Secure`;
  }
  popup.querySelectorAll('.ig-close, .ig-cta').forEach(control => {
    control.addEventListener('click', () => popup.close());
  });
  popup.addEventListener('click', event => {
    if (event.target !== popup) return;
    const bounds = popup.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom) popup.close();
  });
  function prepareAndShow() {
    if (preparing || popup.open || document.visibilityState === 'hidden' || !isDue()) return;
    if (getComputedStyle(popup).getPropertyValue('--ig-popup-ready').trim() !== '1') return;
    fontsReady ||= document.fonts ? Promise.allSettled([
      document.fonts.load('600 42px Poppins'),
      document.fonts.load('500 13px Poppins'),
      document.fonts.load('400 14px Poppins')
    ]) : Promise.resolve();
    preparing = (async () => {
      try {
        await Promise.all([fontsReady, loadVisibleImages()]);
        // A breakpoint can change while images are decoding.
        await loadVisibleImages();
        showIfDue();
      } catch (_) { /* Do not show a popup with missing visible photos. */ }
    })().finally(() => { preparing = null; });
  }
  window.addEventListener('pageshow', prepareAndShow);
  document.addEventListener('visibilitychange', prepareAndShow);
  desktop.addEventListener('change', () => {
    if (popup.open) loadVisibleImages().catch(() => {});
    else prepareAndShow();
  });
  document.getElementById('iglam-sale-popup-styles')?.addEventListener('load', prepareAndShow, { once: true });
  prepareAndShow();
})();
